import { UNITS, CURRENCY_CODE } from '../constants/currency-units';
import { QUALIFICATION_CODES } from '../constants/qualification-code';
import { Criteria } from '../interfaces/quota.interface';
import { ChildrenLabelMapper } from 'purespectrum-lib';
import { Criteria as SurveyCriteria } from '../../shared/interfaces/survey.interface';

export class QuotaHelper {
  public breakArrayAndJoinQuotaViewItem(input: Criteria[]) {
    const retArr: string[] = [];
    const units = UNITS;
    input.forEach((item: Criteria) => {
      if (item.qualification_code === QUALIFICATION_CODES.CHILD_AGE_GENDER) {
        const mapper = new ChildrenLabelMapper(
          item.condition_codes!.map(Number),
          item.child_age_unit
        );
        retArr.push(mapper.label());
      } else if (
        item.condition_names &&
        item.condition_names.length &&
        (!item.range_sets || (item.range_sets && !item.range_sets.length))
      ) {
        item.condition_names.forEach((name: string) => {
          retArr.push(name);
        });
      }
      if (item.range_sets && item.range_sets.length) {
        item.range_sets.forEach((rangeItem: any) => {
          // 321=USA $ & 324 = AU $ defined in dasboard constant file
          if (
            parseInt(rangeItem.units) >= CURRENCY_CODE.US &&
            parseInt(rangeItem.units) <= CURRENCY_CODE.AU
          ) {
            retArr.push(
              units[rangeItem.units] +
                parseInt(rangeItem.from) +
                ' - ' +
                units[rangeItem.units] +
                parseInt(rangeItem.to)
            );
          } else {
            retArr.push(
              parseInt(rangeItem.from) +
                ' ' +
                units[rangeItem.units] +
                ' - ' +
                parseInt(rangeItem.to) +
                ' ' +
                units[rangeItem.units]
            );
          }
        });
      }
    });
    return retArr.toString();
  }

  public getNestedQuotaGroup(quotaCriteria: SurveyCriteria[]) {
    let group_data = '';
    quotaCriteria.forEach((item: SurveyCriteria) => {
      if (item.qualification_name === 'Age' && item.range_sets?.length) {
        const rangeItem = item.range_sets[0];
        group_data = group_data
          ? `${group_data}, ${rangeItem.from} yr - ${rangeItem.to} yr`
          : `${rangeItem.from} yr - ${rangeItem.to} yr`;
      } else if (
        item.qualification_name === 'Household Income' &&
        item.range_sets?.length
      ) {
        const rangeItem = item.range_sets[0];
        group_data = group_data
          ? `${group_data}, ${rangeItem.from} - ${rangeItem.to}`
          : `${rangeItem.from} - ${rangeItem.to}`;
      } else if (item.qualification_name === 'Children') {
        group_data = group_data
          ? `${group_data}, ${this.breakArrayAndJoinQuotaViewItem([item])}`
          : this.breakArrayAndJoinQuotaViewItem([item]);
      } else {
        group_data = group_data
          ? group_data + ', ' + item.condition_names[0]
          : item.condition_names[0];
      }
    });
    return group_data;
  }

  public sortCriteriaByQualificationCode(criteria: Criteria[]) {
    return criteria.sort((prevCriteria: Criteria, currCriteria: Criteria) => {
      return prevCriteria.qualification_code - currCriteria.qualification_code;
    });
  }
}
